import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface MentorshipCareerTrackModalValue {
    name: string;
    childrenText: string;
}

interface MentorshipCareerTrackModalProps {
    show: boolean;
    mode: 'add' | 'edit';
    initialName?: string;
    initialChildrenText?: string;
    onClose: () => void;
    onApply: (value: MentorshipCareerTrackModalValue) => void;
}

const MentorshipCareerTrackModal = ({
    show,
    mode,
    initialName = '',
    initialChildrenText = '',
    onClose,
    onApply,
}: MentorshipCareerTrackModalProps) => {
    const [name, setName] = useState(initialName);
    const [childrenText, setChildrenText] = useState(initialChildrenText);

    useEffect(() => {
        if (!show) return;
        setName(initialName ?? '');
        setChildrenText(initialChildrenText ?? '');
    }, [show, initialName, initialChildrenText]);

    const title = mode === 'edit' ? 'Edit Career Track' : 'Add Career Track';
    const applyLabel = mode === 'edit' ? 'Update Track' : 'Add Track';

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">
                    <div className="col-12">
                        <label className="form-label" htmlFor="mentorship-career-track-name">
                            Career Track Name
                        </label>
                        <input
                            id="mentorship-career-track-name"
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                        />
                    </div>
                    <div className="col-12">
                        <label className="form-label" htmlFor="mentorship-career-track-children">
                            Child / Sub-domain values
                        </label>
                        <textarea
                            id="mentorship-career-track-children"
                            className="form-control"
                            rows={3}
                            value={childrenText}
                            onChange={(event) => setChildrenText(event.target.value)}
                            placeholder="Comma-separated values"
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="success"
                    onClick={() => onApply({ name, childrenText })}>
                    {applyLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MentorshipCareerTrackModal;
